import type { Cart } from '@/types/shopify'
import { atom } from 'nanostores'

export const $cart = atom<Cart | null>(null)
